//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpTableCell',
  props: {
    width: { type: [Number, String], default: null },
  },
  computed: {
    widthString() {
      const { width } = this;
      if (!width) return null;
      return typeof width === 'string' ? width : `${width}px`;
    },
  },
};
